<!-- 文件上传组件 -->
<template>
	<div class="file-image-upload">
		<div v-if="template.show" class="file-template">
			{{ template.desc }}
			<a :href="template.link" target="_blank" rel="noopener noreferrer">
				{{ template.title }}
			</a>
		</div>
		<el-upload
			:on-success="onSuccess"
			:on-remove="onRemove"
			:on-error="onError"
			class="upload-demo"
			:action="`${domain}/upload`"
		  :headers="headers"
			list-type="text"
			:before-upload="beforeUpload"
			:loading="loading"
			:file-list="fileList"
			:accept="accept"
			:disabled="disabled"
			with-credentials
			:limit="limit"
			:multiple="multiple"
			:on-exceed="onExceed"
		>
			<el-button
				size="small"
				type="primary"
				:loading="loading"
				:disabled="disabled"
			>{{ $t("components.upload.uploadField") }}</el-button>
		</el-upload>

	</div>
</template>

<script>
export default {
	name: 'FileImageUpload',
	props: {
		placeholder: {
			type: String,
			default: ''
		},
		value: {
			type: Array,
			default: function() {
				return []
			}
		},

		disabled: {
			type: Boolean,
			default: false
		},
		accept: {
			type: String,
			default: '.pdf,.png,.PNG,.JPG,.jpg,.jpeg,.JPEG,.doc,.xls,.docx,.xlsx,.csv'
		},
		region: {
			type: String,
			default: 'eu'
		},
		multiple: {
			type: Boolean,
			default: false
		},
		limit: {
			type: Number,
			default: 5
		},
		template: {
			type: Object,
			default: function() {
				return {
					show: false,
					'desc': '',
					'link': '',
					'title': ''
				}
	  }
		}
	},
	data: function() {
		return {
			lang: this.$i18n.locale,
			loading: false,
			domain: this.getMerchantFilesUrl(),
			headers: {
				accessToken: window.sessionStorage.getItem('accessToken')
			}
		}
	},

	computed: {
		// 文件列表
		fileList: {
			get() {
				if (this.value && this.value.length > 0) {
					return this.value.map((item) => {
						item.name = item.fileName
						return item
					})
				} else {
					return []
				}
			}
		}
	},

	methods: {
	 // 文件数量超出最大限制
		onExceed(files, fileList) {
			if (fileList.length >= this.limit) {
				this.$notify({
					type: 'error',
					title: `${this.$t('offlineKyc.add.uploadFileImg1st')}${
            this.limit
          }${this.$t('offlineKyc.add.uploadFileImg2nd')}`,
					message: this.$t('offlineKyc.add.uploadFileImgAgain'), // `请删除原图片重新上传`,
					duration: 2000
				})
			}
		},
		onSuccess(response, file, fileList) {
			this.loading = false
			if (response.code !== 200) {
				this.$message.error(this.$t('components.upload.uploadFail'))
	  } else {
				if (response) {
					setTimeout(() => {
						const ret = this.value ? [...this.value] : []
						const { fileName } = response.data
			  ret.push({ fileName, filePath: fileName })

						this.$emit('input', ret)
						this.$emit('change', ret)
					}, 0)
				}
			}
		},
		onRemove(file, fileList) {
			const unDeleteImages = this.value.filter((item) => {
				return item.fileName !== file.fileName
			})

			this.$emit('input', unDeleteImages)
			this.$emit('change', unDeleteImages)
		},
		onError() {
			this.$emit('input', [])
			this.$emit('change', [])

			this.$message({
				type: 'error',
				message: 'Failed to upload, please re-upload...'
			})
		},

		beforeUpload(file) {
			this.loading = true
			const isLt10M = file.size / 1024 / 1024 < 10
			if (!isLt10M) {
				if (this.lang === 'zh') {
					setTimeout(() => {
						this.$message.error(
              `文件 ${file.name} 大小超过10M，请压缩后重新上传`
						)
					}, 0)
				} else {
					setTimeout(() => {
						this.$message.error(
              `The file ${file.name} size is greater than 10M, Please compress the file and re-upload it`
						)
					}, 0)
				}
				this.loading = false
			}
			return isLt10M
		},
	}
}
</script>
<style lang="scss" scoped>
.file-image-upload {
	.upload-demo {
		text-align: left;
	}
	::v-deep .el-upload-list.el-upload-list--text {
		width: 500px;
	}
}
.file-template{
	font-family: PingFangSC-Regular;
	font-size: 14px;
	color: rgba(0,0,0,0.65);
	font-weight: 400;
	a{
		font-family: PingFangSC-Semibold;
		font-size: 14px;
		color: #1FA0E8;
		font-weight: 600;
	}
}
</style>
